import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { formatRoute } from 'react-router-named-routes';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';
import {
  END_USER_RECIPES_ADVANCED_SEARCH_ROUTE,
  END_USER_RECIPES_MULTI_MENUS_ROUTE,
  END_USER_RECIPES_BOARD_ROUTE,
} from '../../services/routes';
import TopNavBar from '../user/top_nav_bar';
import TopNavBarMobileRecipes from './top_nav_bar_mobile_recipes';
import MealBasketWidget from '../../features/end_user_shopping/components/meal_basket_widget';
import { linkWithQueryParams } from '../../services/urls';
import { useAllMultiMenuMeals } from '../common/all_multi_menu_meals_hook';
import {
  HOME_PAGE_CAROUSEL_LIMIT,
  myFavouritesRecipesBoard,
} from '../../services/smorg_board';
import {
  useGetEndUserSpaceQuery,
  useGetOwnedRecipesBoardsQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import RecipesEndUserAppHomePageSection from './recipes_end_user_app_home_page_section';
import { useTracker } from '../../operations/tracking_operations';

const RecipesEndUserAppHomePage = ({ mealDetailVisible }) => {
  const navigate = useNavigate();
  const tracker = useTracker();

  const { data: userProfile } = useGetUserProfileQuery();

  useEffect(() => {
    console.log(`useEffect tracking Recipes clicked, tracker = ${tracker}`);
    tracker(userProfile, ['Recipes screen clicked']);
    // tracker() will mutate userProfile, causing a render loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tracker, !!userProfile]);

  const { data: ownedRecipesBoards } = useGetOwnedRecipesBoardsQuery();

  const myFavBoard = myFavouritesRecipesBoard(ownedRecipesBoards);

  const flattenedFavouriteMealIDs = (myFavBoard?.menus || []).flatMap((menu) =>
    (menu.mealIDs || menu.sharedMealIDs).map((mealID) => ({
      mealID,
      menuID: menu.id,
    })),
  );

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const preferredMenuTitles = currentSpace?.recipesMenuTitles || [];

  const { flattenedSharedBoardsTitleMap, isLoading } = useAllMultiMenuMeals();

  const displayedMenuTitles =
    preferredMenuTitles.length > 0
      ? preferredMenuTitles
      : Object.keys(flattenedSharedBoardsTitleMap || {});

  console.log('isLoading', isLoading);
  console.log('flattenedSharedBoardsTitleMap', flattenedSharedBoardsTitleMap);

  // const {
  //   data: grcRecipeCategories,
  //   error: grcRecipeCategoriesError,
  //   isLoading: isGrcRecipeCategoriesLoading,
  // } = useGetGRCRecipeCategoriesQuery(currentSpaceMembership?.spaceID, {
  //   skip: !currentSpaceMembership?.spaceID,
  // });

  // useEffect(() => {
  //   dispatch(ensureCategoryGRCRecipesLoadedAction());
  // }, [dispatch]);

  return (
    <div className="recipes-view">
      <TopNavBar />
      <TopNavBarMobileRecipes
        recipesBoardSelectorHidden
        popupVisible={mealDetailVisible}
      />
      <MealBasketWidget />
      <div
        style={{
          marginTop: '20px',
        }}>
        <Grid container>
          <Grid
            item
            xs={12}
            onClick={() => navigate(END_USER_RECIPES_ADVANCED_SEARCH_ROUTE)}
            style={{
              padding: '12px',
              paddingLeft: '12px !important',
              textAlign: 'left',
              fontSize: '14px',
              color: 'var(--app-primary-font-color)',
              opacity: 0.5,
              border: '1px solid',
              borderRadius: '8px',
              margin: '8px 16px',
              cursor: 'pointer',
              display: 'flex',
            }}>
            <SearchIcon style={{ margin: 'auto 0' }} />
            <span style={{ paddingTop: '2px' }}>Search recipes</span>
          </Grid>
        </Grid>
        {myFavBoard && flattenedFavouriteMealIDs.length > 0 && (
          <RecipesEndUserAppHomePageSection
            title={myFavBoard.title}
            entries={flattenedFavouriteMealIDs
              .slice(0, HOME_PAGE_CAROUSEL_LIMIT)
              .map(({ mealID, menuID }) => ({
                mealID,
                menuID,
                parentID: myFavBoard.id,
                isDeleteEnabled: true,
              }))}
            viewAllLink={formatRoute(END_USER_RECIPES_BOARD_ROUTE, {
              recipesBoardId: myFavBoard.id,
            })}
            isLoading={isLoading}
          />
        )}
        {displayedMenuTitles.map((menuTitle) => {
          const { menus } = flattenedSharedBoardsTitleMap[menuTitle] || {};
          if (!menus || menus.length === 0) {
            return null;
          }
          const searchParamsArgs = {
            menuIDs: menus.map((m) => m.menuID),
            parentIDs: menus.map((m) => m.parentID),
          };

          const reactKey = searchParamsArgs.menuIDs.join('-');

          const entries = menus.flatMap((menu) =>
            (menu.mealIDs || menu.sharedMealIDs)
              .slice(0, HOME_PAGE_CAROUSEL_LIMIT)
              .map((mealID) => ({
                mealID,
                menuID: menu.menuID,
                parentID: menu.parentID,
                isDeleteEnabled: false,
              })),
          );

          return (
            <RecipesEndUserAppHomePageSection
              key={reactKey}
              title={menuTitle}
              entries={entries}
              viewAllLink={linkWithQueryParams(
                END_USER_RECIPES_MULTI_MENUS_ROUTE,
                searchParamsArgs,
              )}
              isLoading={isLoading && entries.length === 0}
            />
          );
        })}
        {/* (grcRecipeCategories || []).map((category) => (
          <>
            <Grid container>
              <Grid item xs={8}>
                <h2
                  style={{
                    margin: '23px 23px 5px',
                    color: 'var(--app-primary-font-color)',
                    textAlign: 'left',
                  }}>
                  {category.title}
                </h2>
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}>
                <Box
                  sx={{
                    margin: 'auto 10px 7px',
                    color: 'var(--app-primary-font-color)',
                  }}>
                  <Link
                    to={formatRoute(
                      END_USER_RECIPES_GRC_RECIPE_CATEGORY_ROUTE,
                      {
                        categoryID: category.id,
                      },
                    )}>
                    View all
                  </Link>
                </Box>
              </Grid>
            </Grid>

            <div style={{ overflowX: 'auto', display: 'flex' }}>
              {category.result.data.map((item) => (
                <RecipesEndUserGRCRecipeItem
                  key={item.grcRecipeID}
                  grcRecipeID={item.grcRecipeID}
                  favouriteEnabled
                  copyEnabled
                />
              ))}
            </div>
          </>
        )) */}
      </div>
    </div>
  );
};

RecipesEndUserAppHomePage.propTypes = {
  mealDetailVisible: PropTypes.bool.isRequired,
};

export default RecipesEndUserAppHomePage;
